import { render } from "./UENutritionEditView.vue?vue&type=template&id=b7652dd2&scoped=true"
import script from "./UENutritionEditView.vue?vue&type=script&lang=js"
export * from "./UENutritionEditView.vue?vue&type=script&lang=js"

import "./UENutritionEditView.vue?vue&type=style&index=0&id=b7652dd2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7652dd2"]])

export default __exports__